import React from 'react';
import revampData from '../../data/revampData.json';
import { theme, websiteColors } from "../../themes/Theme.js";
const PricingPageIntro = () => {
  const pricingIntroSections = revampData.data.listPricingIntroSections.data[0];
  return <div className='px-sm-4 px-3 font-figtree pricing-intro-container  mb-sm-0' style={{
    color: "#fff",
    height: "260px",
    display: "flex",
    margin: "auto"
  }} data-sentry-component="PricingPageIntro" data-sentry-source-file="PricingPageIntro.jsx">
            <div className="text-center py-5 m-auto">
                    <div className="d-flex justify-content-center align-items-center gap-4">
                        <div className="text-center intro-container d-flex flex-column justify-content-center align-items-center pb-3 ">
                            <span className="text-uppercase intro-txt mb-1 d-block pb-3" style={{
            fontWeight: '600',
            letterSpacing: '2px',
            color: "#C5E2FF"
          }}>
                            {pricingIntroSections.label}                          </span>
                            <h1 className=" section-title "> {pricingIntroSections.title}  </h1>
            
                        </div>
                    </div>
            </div>
            <style jsx>{`

            .pricing-intro-container{
                 background-color: ${websiteColors[theme].primaryWebsiteTheme};
            background-image: url('https://d2nnrpx7gk2my2.cloudfront.net/files/66ffd063cda1b80008a04f76/Group.svg');
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            }
                .intro-container {
                    //max-width: 1000px;
                 width: 100%;
                }
                .section-title{
                    font-weight:600;
                    font-size:48px;
                    line-height:60px;
                    //color:#101828;
                    letter-spacing:2px;
                }
                .section-subtitle{
                font-weight:400;
                    font-size:20px;
                    line-height:30px;
                    //color:#424242;
                }
                @media screen and (max-width: 576px) {
                    .section-title{
                        font-size:32px;
                        max-width:376px;
                    }
                   
                    .intro-txt{
                        letter-spacing:0px !important;
                        padding-top: 7px;
                    }
                    .section-title{
               
                    letter-spacing:0px;
                }
                        .pricing-intro-container{
          
            background-image: url('https://d2nnrpx7gk2my2.cloudfront.net/files/670d1b84ef319700089ec641/eventpage_abstract.webp');
        
            }
                }
            `}</style>
        </div>;
};
export default PricingPageIntro;